/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';

import i18n from 'i18n-react';
import DataTable from 'react-data-table-component';
import { HashLink as Link } from 'react-router-hash-link';

import RewardMenu from 'components/RewardMenu';

import APIHandler from 'config/APIHandler';
import StorageHandler from 'config/StorageHandler';

import BookingState from 'views/BookingsView/BookingState';
import testData from 'views/BookingsView/testdata.json';

import { baseAppId, storageKeys } from 'settings';

const getBookings = async (callback) => {
  try {
    callback(testData);
  } catch (error) {
    // console.log(error);
  }
};

const BookingsView = () => {
  const [bookings, setBookings] = useState([]);
  const [show, setShow] = useState({});
  const [points, setPoints] = useState({});

  useEffect(() => {
    if (bookings.length === 0) {
      getBookings((data) => {
        setBookings(data);
        setShow({
          showKey: 'View All',
          'View All': true,
          data: [...data],
        });
      });
    }
    if (!(points.total >= 0)) {
      StorageHandler.load(storageKeys.accessToken).then((token) => {
        const startDate = '2021-07-21';
        const endDate = '2022-12-21';
        APIHandler.getPoints(baseAppId, startDate, endDate, token).then((res) => {
          setPoints(res.total);
        });
      });
    }
  }, [bookings, points, setBookings, setShow, setPoints]);

  const columns = [
    {
      name: 'points',
      selector: (row) => row.points,
      sortable: true,
    },
    {
      name: 'status',
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: 'first name',
      selector: (row) => row.First_Name,
      sortable: true,
      hide: 'sm',
    },
    {
      name: 'last name',
      selector: (row) => row.Last_Name,
      sortable: true,
    },
    {
      name: 'booking date',
      selector: (row) => row.BookingDate,
      sortable: true,
      hide: 'md',
    },
    {
      name: 'rooms',
      selector: (row) => row.Rooms,
      sortable: true,
    },
    {
      name: 'cost',
      selector: (row) => row.cost,
      sortable: true,
    },
  ];

  return (
    <div className="contentContainer BookingForm">
      <div className="header">
        <Link to="/main">
          <img
            src="https://s3.amazonaws.com/developertool/1441/1686831353-sociallogo120.png"
            alt="Logo"
            className="logo"
          />
        </Link>
        <h3>{i18n.translate('rewards.bookingsView.title')}</h3>
      </div>
      <hr />
      <div className="tableNavHead">
        <p>{`Available Points: ${points.confirmed}`}</p>
        <p>{`Pending Points: ${points.pending}`}</p>
      </div>
      <hr />
      <div className="tableNav">
        {Object.entries(BookingState)
          .sort(([, valueA], [, valueB]) => valueB - valueA)
          .map(([key]) => {
            const booking = bookings.filter(({ status }) => BookingState[key].status.includes(status));

            return (
              <div
                key={key}
                onClick={() =>
                  booking.length &&
                  setShow({
                    showKey: key,
                    [`${key}`]: true,
                    data: [...booking],
                  })
                }
                aria-hidden
              >
                <button type="button" className={show[key] ? 'btn active' : 'btn'}>
                  <span className="head" dangerouslySetInnerHTML={{ __html: key.replace(' ', '<br/>') }} />
                  <span>{booking.length}</span>
                </button>
              </div>
            );
          })}
      </div>
      <div className="table-head">
        <h2>{show.showKey === 'View All' ? 'All Submitted Bookings' : show.showKey}</h2>
      </div>
      <p className="info-message">{i18n.translate('rewards.bookingsView.infoMessage')}</p>
      <div className="table-booking">
        <DataTable className="bookings-table" columns={columns} data={show.data} defaultSortFieldId={1} />
      </div>
      <RewardMenu />
    </div>
  );
};

export default BookingsView;
